import { createContext, useContext, useState, useEffect } from "react";
import { useGetUnreadCount } from "../../../hooks/organization/notification/useGetUnreadCount";

const SchlStudentNotificationContext = createContext();

export const SchlStudentNotificationProvider = ({ children, type }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { getUnreadCount } = useGetUnreadCount();

  // Fetch initial unread count when provider mounts
  useEffect(() => {
    const fetchInitialCount = async () => {
      const count = await getUnreadCount({type});
      if (count !== null && count !== undefined) {
        setUnreadCount(count);
      }
    };
    fetchInitialCount();
  }, [type]);

  return (
    <SchlStudentNotificationContext.Provider
      value={{ unreadCount, setUnreadCount }}
    >
      {children}
    </SchlStudentNotificationContext.Provider>
  );
};

export const useSchlStudentNotification = () =>
  useContext(SchlStudentNotificationContext);
